// NoHeaderFooterLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function NoHeaderFooterLayout() {
  return (
    <div className="no-header-footer-layout">
      <Outlet />
    </div>
  );
}
